var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShippingIconCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #000;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.4,2.5c4.7,0,9.3,0,13.9-.1,10.3,0,20.1,0,29.4,4.9,9.8,10.2,9,23.8,9,37.2-.1,5.4-.3,10.9-.4,16.3-.3,12.2-.5,24.4-.8,37H3.5c-.3-12.2-.5-24.4-.8-37-.1-3.8-.2-7.6-.3-11.6Q1.8,21.5,7.8,10.9C17.5.9,32.4,2.2,45.4,2.5ZM17.6,21.6h64.8q-4.5-8.9-11.1-9.5c-2.2,0-4.4,0-6.6,0-1.2,0-2.3,0-3.5,0-2.5,0-4.9,0-7.4,0-3.8,0-7.5,0-11.3,0-2.4,0-4.8,0-7.2,0-1.1,0-2.2,0-3.4,0-9.1.2-8.7,1.2-14.3,9.6ZM12,30.1v59.2h76.1V30.1H12Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.1,38.5h33.8v8.5h-33.8v-8.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.5,76.6h25.4v8.5h-25.4v-8.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M78.2,59.7c1.9.9,3.7,1.9,5.6,2.8v9.9h-8.5q-.2-4.8,0-9.9c.9-.9,1.9-1.9,2.8-2.8Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.3,59.7c1.9.9,3.7,1.9,5.6,2.8v9.9h-8.5q-.2-4.8,0-9.9c.9-.9,1.9-1.9,2.8-2.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShippingIconCopy);
export default __webpack_public_path__ + "static/media/shipping-icon-copy.d45226cf1ff139de01f3446026f144cd.svg";
export { ForwardRef as ReactComponent };